import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionButton = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 6,
	height: 10,
	fill: "{fill}",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "{fill}",
		d: "M3 7.917c-.31 0-.562-.28-.562-.625 0-.808.507-1.546 1.466-2.133.715-.437 1.084-1.304.942-2.208-.133-.835-.75-1.52-1.5-1.667a1.745 1.745 0 0 0-1.502.406 2.157 2.157 0 0 0-.72 1.483c-.024.344-.295.602-.604.576-.31-.027-.542-.327-.518-.67C.065 2.145.486 1.28 1.154.702c.68-.587 1.527-.817 2.385-.65C4.75.29 5.742 1.392 5.954 2.735c.224 1.416-.382 2.83-1.507 3.52-.553.338-.884.726-.884 1.037 0 .345-.252.625-.563.625Zm-.562 1.458c0 .345.252.625.562.625.311 0 .563-.28.563-.625S3.311 8.75 3 8.75c-.31 0-.562.28-.562.625Z"
	})
});
export default SvgQuestionButton;
